import { useCallback } from "react";
import { Button } from "@design-system/Button/Button";
import { WithHotkey } from "@design-system/Button/WithHotkey";
import { CommandIsland } from "@design-system/CommandIsland/CommandIsland";
import { useSettings } from "@components/settings/SettingsProvider";

export const InviteAccountantCommandIsland = () => {
    const { open: openSettings } = useSettings();

    const handleOpenMembers = useCallback(
        () => openSettings(["members"]),
        [openSettings],
    );

    return (
        <CommandIsland alignEnd>
            <WithHotkey
                hotKey="mod+enter"
                hotKeyDisplayPosition="inline"
                hotKeyOptions={{
                    preventDefault: true,
                    description: "Open Members",
                }}
            >
                {(hotkeyHint) => (
                    <Button
                        onClick={handleOpenMembers}
                        variant="primary"
                        size="md"
                        rightIcon={hotkeyHint}
                    >
                        Open Members
                    </Button>
                )}
            </WithHotkey>
        </CommandIsland>
    );
};
